import * as React from 'react';
import { ILinkedRoute } from './../types'
import { RouteChildrenProps, Redirect } from 'react-router';
import { useCurrentRoute } from 'src/modules/Routing/auth/useCurrentRoute';
import { TermsOfUseView } from 'src/modules/Auth/TermsOfUse/TermsOfUse';
import Routes from 'src/modules/Routing/routes';
import { useAuthValidator } from 'src/modules/Auth/hooks/useAuthValidator';

export interface IAuthRoute {
  linkedRoute: ILinkedRoute
  match: RouteChildrenProps<any, any>
}
const AuthRoute: React.SFC<IAuthRoute> = ({ linkedRoute, match }) => {
  const { component: Component, policies, path, showNavBar } = linkedRoute;
  const [, setCurrentRoute] = useCurrentRoute()
  const { showTermsOfUse, auth } = useAuthValidator(policies);
  React.useEffect(() => {
    setCurrentRoute({ path, showNavBar })
  }, [linkedRoute]);
  React.useEffect(() => {
    if (showTermsOfUse) {
      setCurrentRoute(prev => ({ ...prev, showNavBar: false }));
    }
  }, [showTermsOfUse]);
  if (showTermsOfUse) {
    return <TermsOfUseView needsToAccept={showTermsOfUse} />
  }
  if (auth.authorized) {
    return <Component {...match} />
  }
  if (auth.forbidden) {
    return <Redirect to={{ pathname: Routes.FORBIDDEN }} />
  }
  const redirectTo = Routes.ROOT ? "" : match.location.pathname;
  return <Redirect to={{ pathname: `/login${redirectTo}`, state: { from: match.location } }} />
}

export default React.memo(AuthRoute);